export default __webpack_public_path__ + "static/media/git.fd381642.svg";